module.exports = __webpack_public_path__ + "img/pr-39.1ad61af9.png";